<template>
	<div class="chat-message-item" :class="active ? 'active' : ''">
		<div class="message-tip" :class="{ 'message-tip-risk': isRiskTip }" v-if="message.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ message.content }}
		</div>
		<div class="message-tip" v-else-if="message.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(message.sendTime) }}
		</div>
		<!-- 系统通知: 后端以虚拟发送人 id=1 下发的自动通知(订单流转/提醒等),居中卡片展示 -->
		<div class="message-system-notice" v-else-if="message.sendId == 1" @contextmenu.prevent="showRightMenu($event)">
			<div class="sys-notice-card" :class="orderNoticeClass">
				<div class="sys-notice-head">
					<span class="sys-notice-title"><i class="el-icon-bell"></i>系统通知</span>
					<span class="sys-notice-time">{{ $date.toTimeText(message.sendTime) }}</span>
				</div>
				<div class="sys-notice-body"><span v-html="htmlText"></span></div>
			</div>
		</div>
		<div class="message-normal" v-else-if="isNormal" :class="{ 'message-mine': mine, 'select-mode': selectMode }"
			@click="onRowClick">
			<div class="msg-select" v-if="selectMode">
				<i :class="selected ? 'el-icon-success msg-select-on' : 'el-icon-circle-check'"></i>
			</div>
			<div class="head-image">
				<head-image :name="displayName" :size="38" :url="displayHeadImage" :id="message.sendId"></head-image>
			</div>
			<div class="content">
				<div v-show="(mode == 1 && message.groupId && !message.selfSend) || proxySender" class="message-top">
					<span>{{ displayName }}</span>
					<span v-if="proxySender">{{ $date.toTimeText(message.sendTime) }}</span>
				</div>
				<div v-show="mode == 2" class="message-top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(message.sendTime) }}</span>
				</div>
				<div class="message-bottom" @contextmenu.prevent="showRightMenu($event)">
					<div ref="chatMsgBox" class="message-content-wrapper">
						<span v-if="favorited" class="favorite-star" title="已收藏"><i class="el-icon-star-on"></i></span>
						<div class="message-text message-text-box" :class="[{ 'emoji-only-msg': isEmojiOnly }, orderNoticeClass]" v-if="isTextMessage">
							<div class="quote-box" v-if="quoteMessage" @click="onClickQuote">
								<span class="quote-name">{{ quoteMessage.name }}</span>
								<span class="quote-content">{{ quoteMessage.content }}</span>
							</div>
							<span v-html="htmlText"></span>
						</div>
						<div class="message-image" v-else-if="message.type == $enums.MESSAGE_TYPE.IMAGE"
							@click="showFullImageBox()">
							<img :style="imageStyle" :src="contentData.thumbUrl" loading="lazy" draggable="false" @dragstart.prevent />
						</div>
						<div class="message-video" v-else-if="message.type == $enums.MESSAGE_TYPE.VIDEO">
							<div class="video-wrapper" :style="imageStyle" v-if="!videoPlaying" @click="videoPlaying=true">
								<img v-if="contentData.thumbUrl" class="video-poster-img" :src="contentData.thumbUrl" />
								<div class="video-play-btn"><span class="play-icon">&#9654;</span></div>
							</div>
							<video v-else :style="imageStyle" :poster="contentData.thumbUrl"
								controls autoplay preload="metadata" playsinline>
								<source :src="contentData.url" type="video/mp4" />
							</video>
							<span class="video-duration" v-if="contentData.duration && !videoPlaying">{{ durationText }}</span>
						</div>
						<div class="message-file" v-else-if="message.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="sending">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" type="primary"
										@click="onDownloadFile">{{ contentData.name
										}}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<div class="message-voice" v-else-if="message.type == $enums.MESSAGE_TYPE.AUDIO"
							@click="onPlayVoice()">
							<audio controls :src="JSON.parse(message.content).url"></audio>
						</div>
						<div class="message-text message-merge" v-else-if="message.type == $enums.MESSAGE_TYPE.MERGE"
							@click="onOpenMerge">
							<div class="merge-title">
								<i class="el-icon-chat-line-square"></i>
								<span>{{ mergeData.title || '聊天记录' }}</span>
							</div>
							<div class="merge-preview">
								<div class="merge-line" v-for="(r, i) in mergePreviewRecords" :key="i">
									<span class="merge-line-name">{{ r.sendNickName }}：</span>
									<span class="merge-line-text">{{ mergeLinePreview(r) }}</span>
								</div>
							</div>
							<div class="merge-footer">查看 {{ mergeRecordCount }} 条转发消息</div>
						</div>
						<div title="发送中" v-if="sending" class="sending" v-loading="'true'"></div>
						<div title="发送失败" v-else-if="sendFail" @click="onSendFail" class="send-fail el-icon-warning">
						</div>
					</div>
					<div class="chat-action message-text" v-if="isAction">
						<span v-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ message.content }}</span>
					</div>
					<div class="message-status" v-if="!isAction && message.selfSend && !isGroupMessage">
						<span class="chat-readed" v-if="isReaded">已读</span>
						<span class="chat-unread" v-else>未读</span>
					</div>
					<div class="chat-receipt" v-show="message.receipt && message.selfSend" @click="onShowReadedBox">
						<span v-if="message.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ message.readedCount }}人已读</span>
					</div>
				</div>
				<div class="edited-tip" v-if="message.edited">已编辑</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-group-readed ref="chatGroupReadedBox" :message="message" :group="group"></chat-group-readed>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		mode: {
			type: Number,
			default: 1
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			required: true
		},
		showName: {
			type: String,
			required: true
		},
		conversation: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
		},
		message: {
			type: Object,
			required: true
		},
		menu: {
			type: Boolean,
			default: true
		},
		selectMode: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Boolean,
			default: false
		},
		favorited: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			audioPlayState: 'STOP',
			quoteMessage: null,
			videoPlaying: false
		}
	},
	methods: {
		onDownloadFile() {
			const url = this.contentData.url;
			const name = this.contentData.name || '文件';
			if (!url) {
				return;
			}
			const ua = navigator.userAgent;
			// iOS(含iPad Safari)和微信内置浏览器不支持/不兼容 a[download]，
			// 点击会报“网站出问题啦”，改用 fetch→blob→ObjectURL 方式下载，失败时降级为打开预览
			const needBlobDownload = /iPad|iPhone|iPod/.test(ua)
				|| (/Macintosh/.test(ua) && 'ontouchend' in document)
				|| /MicroMessenger/i.test(ua);
			if (needBlobDownload) {
				fetch(url).then((res) => {
					if (!res.ok) {
						throw new Error('下载失败:' + res.status);
					}
					return res.blob();
				}).then((blob) => {
					const blobUrl = URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = blobUrl;
					a.download = name;
					document.body.appendChild(a);
					a.click();
					a.remove();
					setTimeout(() => URL.revokeObjectURL(blobUrl), 3000);
				}).catch(() => {
					// blob下载失败(如微信拦截)降级为打开预览，PDF等可直接在线查看
					window.open(url, '_blank');
				});
				return;
			}
			// 桌面/安卓浏览器: a[download] 同源链接直接下载(不能加 target=_blank，
			// 否则新标签页导航被下载中断会报“网站出问题啦”)
			const a = document.createElement('a');
			a.href = url;
			a.download = name;
			document.body.appendChild(a);
			a.click();
			a.remove();
		},
		onSendFail() {
			this.$emit("resend", this.message);
		},
		showFullImageBox() {
			if (this.selectMode) {
				return;
			}
			let imageUrl = JSON.parse(this.message.content).originUrl;
			if (imageUrl) {
				// 收集当前会话中所有图片的原始URL，用于画廊浏览
				let imageUrls = [];
				try {
					imageUrls = this.chatStore.messages
						.filter(m => m.type == this.$enums.MESSAGE_TYPE.IMAGE)
						.map(m => {
							try { return JSON.parse(m.content).originUrl; }
							catch(e) { return null; }
						})
						.filter(u => u);
				} catch(e) {
					// chatStore 不可用时回退为单图模式
				}
				this.$eventBus.$emit("openFullImage", imageUrl, imageUrls);
			}
		},
		// 多选模式下点击整行切换选中状态
		onRowClick() {
			if (this.selectMode && this.canForward) {
				this.$emit('toggleselect', this.message);
			}
		},
		// 打开合并转发的聊天记录
		onOpenMerge() {
			if (this.selectMode) {
				this.onRowClick();
				return;
			}
			this.$emit('openmerge', this.message);
		},
		mergeLinePreview(r) {
			return this.$msgUtil.previewContent(r);
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = JSON.parse(this.message.content).url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		showRightMenu(e) {
			if (this.selectMode) {
				return;
			}
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			if (item.key == 'COPY_IMAGE') {
				this.copyImage();
				return;
			}
			this.$emit(item.key.toLowerCase(), this.message);
		},
		// 消息页右键图片直接复制: 拉取原图blob(非png经canvas转png)写入剪贴板
		async copyImage() {
			try {
				const url = this.contentData.originUrl || this.contentData.url || this.contentData.thumbUrl;
				if (!url) {
					throw new Error('no url');
				}
				const resp = await fetch(url);
				if (!resp.ok) {
					throw new Error('fetch ' + resp.status);
				}
				let blob = await resp.blob();
				if (blob.type !== 'image/png') {
					blob = await new Promise((resolve, reject) => {
						const img = new Image();
						const objUrl = URL.createObjectURL(blob);
						img.onload = () => {
							const canvas = document.createElement('canvas');
							canvas.width = img.naturalWidth;
							canvas.height = img.naturalHeight;
							canvas.getContext('2d').drawImage(img, 0, 0);
							URL.revokeObjectURL(objUrl);
							canvas.toBlob(b => (b ? resolve(b) : reject(new Error('toBlob fail'))), 'image/png');
						};
						img.onerror = () => {
							URL.revokeObjectURL(objUrl);
							reject(new Error('img load fail'));
						};
						img.src = objUrl;
					});
				}
				await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
				this.$message.success('图片已复制，可直接粘贴');
			} catch (e) {
				console.warn('复制图片失败:', e);
				this.$message.error('复制失败，请双击打开图片后右键复制');
			}
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		onClickQuote() {
			if (this.quoteMessage && this.quoteMessage.localId) {
				this.$emit('locate', { localId: this.quoteMessage.localId });
			}
		},
		async resolveQuote() {
			this.quoteMessage = null;
			const quoteId = this.message.quoteId;
			if (!quoteId) {
				return;
			}
			// 先从当前会话内存查找，再回退到本地数据库
			let qm = this.chatStore.messages.find(m => m.id == quoteId);
			if (!qm && this.message.convKey) {
				qm = await this.$db.findMessageById(this.message.convKey, quoteId);
			}
			if (qm) {
				this.quoteMessage = {
					name: this.resolveQuoteName(qm),
					content: this.$msgUtil.previewContent(qm),
					localId: qm.localId
				};
			} else {
				this.quoteMessage = { name: '', content: '[引用的消息]', localId: null };
			}
		},
		resolveQuoteName(qm) {
			const myId = this.userStore.userInfo.id;
			if (qm.sendId == myId) {
				return '我';
			}
			if (qm.sendNickName) {
				return qm.sendNickName;
			}
			if (this.group && this.group.members) {
				const mem = this.group.members.find(x => x.userId == qm.sendId);
				if (mem) {
					return mem.showNickName;
				}
			}
			return this.conversation.showName || '';
		}
	},
	created() {
		this.resolveQuote();
	},
	watch: {
		'message.quoteId': {
			handler() {
				this.resolveQuote();
			}
		}
	},
	computed: {
		sending() {
			return this.message.status == this.$enums.MESSAGE_STATUS.SENDING;
		},
		sendFail() {
			return this.message.status == this.$enums.MESSAGE_STATUS.FAILED;
		},
		contentData() {
			return JSON.parse(this.message.content)
		},
		// 代发消息: 私聊中发送者既非自己也非会话对象(如芝麻接待会话镜像进来的财务回复)
		proxySender() {
			return !this.message.groupId && !this.message.selfSend
				&& this.conversation && this.conversation.targetId
				&& this.message.sendId != this.conversation.targetId;
		},
		displayName() {
			if (this.proxySender && this.message.sendNickName) {
				return this.message.sendNickName;
			}
			return this.showName;
		},
		displayHeadImage() {
			if (this.proxySender && this.message.sendHeadImage) {
				return this.message.sendHeadImage;
			}
			return this.headImage;
		},
		fileSize() {
			let size = this.contentData.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		durationText() {
			// 将秒数格式化为 mm:ss
			let d = Math.round(this.contentData.duration || 0);
			let m = Math.floor(d / 60);
			let s = d % 60;
			return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
		},
		menuItems() {
			let items = [];
			// 图片消息: 右键直接复制, 无需先打开查看
			if (this.message.type == this.$enums.MESSAGE_TYPE.IMAGE) {
				items.push({
					key: 'COPY_IMAGE',
					name: '复制图片'
				});
			}
			if (this.isTextMessage) {
				items.push({
					key: 'COPY',
					name: '复制'
				});
			}
			// 引用回复（已发送成功的普通消息）
			if (this.isNormal && this.message.id > 0) {
				items.push({
					key: 'QUOTE',
					name: '引用'
				});
			}
			// 置顶（已发送成功的普通消息）
			if (this.isNormal && this.message.id > 0) {
				items.push({
					key: 'PIN',
					name: '置顶'
				});
			}
			// 收藏（已发送成功的普通消息）
			if (this.isNormal && this.message.id > 0) {
				items.push({
					key: 'FAVORITE',
					name: this.favorited ? '取消收藏' : '收藏'
				});
			}
			// 转发 / 多选（已发送成功的普通消息）
			if (this.canForward) {
				items.push({
					key: 'FORWARD',
					name: '转发'
				});
				items.push({
					key: 'MULTISELECT',
					name: '多选'
				});
			}
			// 编辑（自己发送的文字消息）
			if (this.isTextMessage && this.message.selfSend && this.message.id > 0) {
				items.push({
					key: 'EDIT',
					name: '编辑'
				});
			}
			items.push({
				key: 'DELETE',
				name: '删除',
				danger: true
			});
			if (this.message.selfSend && this.message.id > 0) {
				items.push({
					key: 'RECALL',
					name: '撤回'
				});
			}
			return items;
		},
		isTextMessage() {
			return this.message.type == this.$enums.MESSAGE_TYPE.TEXT
		},
		// 系统通知的气泡样式：访问通知蓝色背景白字，取消通知红色，回款/收款/放行通知浅绿色，普通订单通知蓝色左边框
		orderNoticeClass() {
			if (!this.isTextMessage) {
				return ''
			}
			const content = this.message.content || ''
			// 访问通知(蓝色气泡白色字)
			if (content.indexOf('有新设备访问') >= 0) {
				return 'track-visit-notice'
			}
			if (content.indexOf('订单号：') < 0) {
				return ''
			}
			if (content.indexOf('取消，原因：') >= 0 || content.indexOf('系统已自动关单') >= 0) {
				return 'order-notice-cancel'
			}
			if (content.indexOf('已回款') >= 0 || content.indexOf('已确认收到回款') >= 0 ||
				content.indexOf('已确认收款') >= 0 || content.indexOf('已放行') >= 0 ||
				content.indexOf('已转款') >= 0) {
				return 'order-notice-receipt'
			}
			return 'order-notice'
		},
		// 纯表情消息：内容仅由有效表情编码组成（无其它可见文字），用于放大展示且不显示气泡
		isEmojiOnly() {
			if (!this.isTextMessage || this.quoteMessage) {
				return false;
			}
			const content = (this.message.content || '').trim();
			if (!content) {
				return false;
			}
			let count = 0;
			const rest = content.replace(this.$emo.EMOJI_REGEX, (m) => {
				const word = this.$emo.parseEmojiWord(m);
				if (this.$emo.emoTextList.includes(word)) {
					count++;
					return '';
				}
				return m;
			});
			return count > 0 && count <= 3 && rest.trim().length === 0;
		},
		// 可转发：已发送成功的普通消息（排除通话等交互消息）
		canForward() {
			return this.$msgType.isNormal(this.message.type) && this.message.id > 0;
		},
		mergeData() {
			if (this.message.type != this.$enums.MESSAGE_TYPE.MERGE) {
				return {};
			}
			try {
				return JSON.parse(this.message.content) || {};
			} catch (e) {
				return {};
			}
		},
		mergeRecordCount() {
			return (this.mergeData.records || []).length;
		},
		mergePreviewRecords() {
			return (this.mergeData.records || []).slice(0, 3);
		},
		isAction() {
			return this.$msgType.isAction(this.message.type);
		},
		// 芝麻风控警告提示(内容含「异常风险」):标红醒目展示(2026-08-20)
		isRiskTip() {
			return (this.message.content || '').indexOf('异常风险') >= 0;
		},
		isNormal() {
			const type = this.message.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		isReaded() {
			return this.message.status == this.$enums.MESSAGE_STATUS.READED || this.conversation.maxReadedId >= this.message.id
		},
		htmlText() {
			// 访问通知也用白色链接(蓝色气泡上的链接需白色才可见)
			let isVisitNotice = this.isTextMessage && (this.message.content || '').indexOf('有新设备访问') >= 0;
			let color = (this.message.selfSend || isVisitNotice) ? 'white' : '';
			let text = this.$str.html2Escape(this.message.content)
			text = this.$url.replaceURLWithHTMLLinks(text, color)
			return this.$emo.transform(text, this.isEmojiOnly ? 'emoji-sticker' : 'emoji-normal')
		},
		isGroupMessage() {
			return !!this.message.groupId;
		},
		imageStyle() {
			// 计算图片的显示宽高，要求：任意边不能高于360px,不能低于60px,不能拉伸图片比例
			let maxSize = this.configStore.fullScreen ? 360 : 240;
			let minSize = 60;
			let width = this.contentData.width;
			let height = this.contentData.height;
			if (width && height) {
				let ratio = Math.min(width, height) / Math.max(width, height);
				let w = Math.max(Math.min(width > height ? maxSize : ratio * maxSize, width), minSize);
				let h = Math.max(Math.min(width > height ? ratio * maxSize : maxSize, height), minSize);
				return `width: ${w}px;height:${h}px;object-fit: cover;`
			} else {
				// 兼容历史版本，历史数据没有记录宽高
				return `max-width: ${maxSize}px;min-width:60px;max-height: ${maxSize}px;min-height:60px;`
			}
		}
	}
}
</script>

<style lang="scss">
.chat-message-item {
	padding: 3px 10px;
	border-radius: 10px;

	&.active {
		background: var(--im-background-active-dark);
	}

	.message-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);

		// 芝麻风控警告:红色加粗,财务一眼可辨
		&.message-tip-risk {
			color: #f56c6c;
			font-weight: 600;
		}
	}

	// 系统通知居中卡片(虚拟发送人 id=1)
	.message-system-notice {
		display: block;
		width: 100%;
		text-align: center;
		margin-top: 10px;

		.sys-notice-card {
			// 与时间分隔符("几分钟前")同为居中展示,无边框无左侧色条,仅保留底色
			display: inline-block;
			max-width: 480px;
			min-width: 200px;
			margin: 0 auto;
			background: #f7f9fc;
			border-radius: 6px;
			padding: 6px 12px;
			font-size: var(--im-font-size-small);
			color: #303133;
			text-align: left;

			.sys-notice-head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 16px;

				.sys-notice-title {
					font-weight: 600;
					color: var(--im-color-primary);

					i {
						margin-right: 3px;
					}
				}

				.sys-notice-time {
					font-size: var(--im-font-size-smaller);
					color: var(--im-text-color-light);
					font-weight: normal;
				}
			}

			.sys-notice-body {
				margin-top: 4px;
				line-height: 20px;
				white-space: pre-wrap;
				word-break: break-all;
			}

			// 订单取消(红) / 回款(绿) 变体,仅保留底色不再带边框色条
			&.order-notice-cancel {
				background: #fdecec;
				color: #c0392b;

				.sys-notice-head .sys-notice-title {
					color: #f56c6c;
				}
			}

			&.order-notice-receipt {
				background: #e8f5e9;
				color: #2e7d32;

				.sys-notice-head .sys-notice-title {
					color: #67c23a;
				}
			}
		}
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin-top: 10px;

		// 多选模式：整行可点选，头像右移腾出选中图标位置
		.msg-select {
			position: absolute;
			left: 4px;
			top: 50%;
			transform: translateY(-50%);
			z-index: 2;
			font-size: 22px;
			color: var(--im-text-color-light);

			.msg-select-on {
				color: var(--im-color-primary);
			}
		}

		&.select-mode {
			cursor: pointer;
			padding-left: 78px;

			.head-image {
				left: 30px;
			}
		}

		&.message-mine.select-mode {
			padding-left: 0;
			padding-right: 78px;

			.head-image {
				left: auto;
				right: 30px;
			}

			.msg-select {
				left: auto;
				right: 4px;
			}
		}

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.content {
			text-align: left;

			.message-top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 12px;
				}
			}

			.message-bottom {
				display: inline-block;
				// 用百分比 max-width 限制气泡宽度(而非固定 300px 右侧留白):
				// 固定留白在聊天区变窄时(订单面板展开/小窗口)会超过容器宽度,
				// 被 .content-box 的 overflow:hidden 裁掉,导致消息右侧看不到。
				max-width: 72%;
				box-sizing: border-box;
				padding-right: 5px;
				padding-left: 5px;


				.message-content-wrapper {
					position: relative;
					display: flex;
					align-items: flex-end;

					.favorite-star {
						position: absolute;
						top: -6px;
						right: -6px;
						color: #ffb74d;
						font-size: 14px;
						z-index: 2;
						line-height: 1;
						text-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
					}

					.sending {
						width: 25px;
						height: 25px;

						.circular {
							width: 25px;
							height: 25px;
						}
					}

					.send-fail {
						color: #e45050;
						font-size: 30px;
						cursor: pointer;
						margin: 0 5px;
					}
				}

				.message-text {
					flex: 1;
					display: inline-block;
					position: relative;
					line-height: 26px;
					padding: 6px 10px;
					background-color: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-word;

					&.emoji-only-msg {
						background-color: transparent !important;
						padding: 0;
						line-height: normal;
						border-radius: 0;
					}

					// 访问通知气泡(蓝色背景白色字)
					&.track-visit-notice {
						background-color: var(--im-color-primary) !important;
						color: #fff !important;
						border-left: 3px solid var(--im-color-primary);
					
						.quote-box {
							background: rgba(255, 255, 255, 0.22);
							border-left-color: #fff;
					
							.quote-name {
								color: #fff;
							}
					
							.quote-content {
								color: rgba(255, 255, 255, 0.9);
							}
						}
					}
					
					// 订单通知气泡(蓝色左边框)
					&.order-notice {
						border-left: 3px solid var(--im-color-primary);
					}

					// 订单取消通知气泡(红色背景)
					&.order-notice-cancel {
						background-color: #fdecec !important;
						border-left: 3px solid #f56c6c;
						color: #c0392b !important;
					}
											
					// 订单回款通知气泡(浅绿色背景)
					&.order-notice-receipt {
						background-color: #e8f5e9 !important;
						border-left: 3px solid #67c23a;
						color: #2e7d32 !important;
					}

					.quote-box {
						display: block;
						margin-bottom: 4px;
						padding: 4px 8px;
						border-left: 3px solid var(--im-color-primary);
						background: rgba(0, 0, 0, 0.05);
						border-radius: 4px;
						font-size: var(--im-font-size-small);
						line-height: 18px;
						cursor: pointer;
						max-width: 100%;
						overflow: hidden;

						.quote-name {
							color: var(--im-color-primary);
							margin-right: 6px;
							font-weight: 600;
						}

						.quote-content {
							color: var(--im-text-color);
							white-space: nowrap;
							text-overflow: ellipsis;
							overflow: hidden;
						}
					}
				}

				.message-image {
					border-radius: 8px;
					border: 2px solid var(--im-color-primary-light-9);
					overflow: hidden;
					cursor: pointer;
					background: var(--im-background);
				}

				.message-video {
					position: relative;
					border-radius: 8px;
					border: 2px solid var(--im-color-primary-light-9);
					overflow: hidden;
					background: #000;
					line-height: 0;

					.video-wrapper {
						position: relative;
						cursor: pointer;
						overflow: hidden;
						border-radius: 6px;

						.video-poster-img {
							width: 100%;
							height: 100%;
							object-fit: cover;
							display: block;
						}

						.video-play-btn {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							width: 40px;
							height: 40px;
							border-radius: 50%;
							background: rgba(0, 0, 0, 0.5);
							display: flex;
							align-items: center;
							justify-content: center;

							.play-icon {
								color: #fff;
								font-size: 16px;
								margin-left: 2px;
							}
						}
					}

					video {
						display: block;
						border-radius: 6px;
						object-fit: cover;
						background: #000;
					}

					.video-duration {
						position: absolute;
						right: 6px;
						bottom: 6px;
						padding: 0 6px;
						border-radius: 8px;
						background: rgba(0, 0, 0, 0.5);
						color: #fff;
						font-size: 12px;
						line-height: 18px;
						pointer-events: none;
					}
				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-bottom: 2px;
					background: var(--im-background);

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 10px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 44px;
							color: #d42e07;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				.message-voice {
					font-size: 14px;
					cursor: pointer;

					audio {
						height: 45px;
						padding: 5px 0;
					}
				}

				// 合并转发的聊天记录卡片
				.message-merge {
					min-width: 180px;
					max-width: 260px;
					cursor: pointer;

					.merge-title {
						display: flex;
						align-items: center;
						font-weight: 600;
						margin-bottom: 6px;

						i {
							margin-right: 6px;
						}
					}

					.merge-preview .merge-line {
						font-size: var(--im-font-size-smaller);
						line-height: 18px;
						opacity: 0.75;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.merge-footer {
						margin-top: 6px;
						padding-top: 6px;
						border-top: 1px solid rgba(0, 0, 0, 0.12);
						font-size: var(--im-font-size-smaller);
						opacity: 0.9;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.message-status {
					margin-top: 3px;
					display: block;

					.chat-readed {
						font-size: 12px;
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-success);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}

			.edited-tip {
				margin-top: 2px;
				padding: 0 2px;
				font-size: var(--im-font-size-smaller);
				color: var(--im-text-color-light);
			}
		}


		&.message-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 48px;

			.head-image {
				left: auto;
				right: 0;
			}

			.content {
				text-align: right;

				.message-top {
					flex-direction: row-reverse;

					span {
						margin-left: 12px;
						margin-right: 0;
					}
				}

				.message-bottom {
					padding-left: 5px;
					padding-right: 5px;

					.message-content-wrapper {
						flex-direction: row-reverse;
					}

					.message-text {
						background-color: var(--im-color-primary-light-2);
						color: #fff;

						.quote-box {
							background: rgba(255, 255, 255, 0.22);
							border-left-color: #fff;

							.quote-name {
								color: #fff;
							}

							.quote-content {
								color: rgba(255, 255, 255, 0.9);
							}
						}
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}

	}
}
</style>